module.exports = __webpack_public_path__ + "img/intro_sub_no.4fc62fba.svg";